import React, { ReactElement } from "react";
import classnames from 'classnames';

let Styles: any;

try {
    Styles = require('./ButtonImage_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{
    Styles = require('./ButtonImage.module.scss');
}

interface ButtonImageProps {
  id: string,
  onClick: any,
  textoButton: string,
  styleClass: string,
  minWidth?: string,
  maxWidth?: string,
  align?: string,//flex-row--reverse
  icon?: ReactElement
}

const ButtonImage: React.FC<ButtonImageProps> = (props: ButtonImageProps) => {
  const { id, onClick, textoButton, styleClass, minWidth, maxWidth, align, icon } = props;
  return (

    <button
      id={id}
      onClick={onClick}
      className={classnames(Styles.defaultButton, styleClass, "text-center")}
          style={{ minWidth: minWidth, maxWidth: maxWidth }}>
          <div className={classnames(align, Styles.row, "text-left")}>
                <div className= {classnames(Styles.marginPadding, "col-lg-auto col-3 align-self-center")}>{icon}</div>
                <div className= {classnames(Styles.marginPadding, "col-lg-auto col-9 align-self-center")}>{textoButton}</div>
           </div>
    </button>
  );
};

export default ButtonImage;